import { forwardRef } from 'react';
import { Text } from '@weareconceptstudio/core';

//* Styles
import TagStyle from './style';

const Tag = forwardRef(({ children, index = null, white, onClick = null, active = false, className = '', isLargeVersion = false, isExtraVersion = false }, ref) => {
	return (
		<TagStyle
			ref={ref}
			className={`tag-container ${active ? 'active' : ''} ${isLargeVersion ? 'large-version' : ''} ${isExtraVersion ? 'extra-version' : ''} ${onClick ? 'hover-version' : ''} ${className}`}
			$index={index}
			$white={white}
			onClick={onClick}
		>
			<Text className={`tag-wrapper montserrat-500`}>{children}</Text>
		</TagStyle>
	);
});

Tag.displayName = 'Tag';

export default Tag;
